export const DEFAULT_REQUIRED_ERROR_MESSAGE = '* Required fields in red are missing.';
export const MATCH_PATTERN_ERROR_MESSAGE = `Include more matching characters. The value cannot be only the asterisk (* ) wildcard.`;
